'use client';

import { logger } from '@tuic/logger';
import { cloneElement, isValidElement } from 'react';
import { twJoin } from 'tailwind-merge';

import { isElementWithProps } from '../../../utils';

import type { FC, ReactNode } from 'react';

export type ContentCardWrapperProps = {
  children: ReactNode;
  wrap?: ReactNode;
};

export const ContentCardWrapper: FC<ContentCardWrapperProps> = ({
  children,
  wrap,
}) => {
  if (isValidElement(wrap) && isElementWithProps(wrap)) {
    if (wrap.props.children) {
      logger.error(
        'Content Card does only support one level of children in the "wrap" property.',
        wrap,
      );
    }

    return cloneElement(
      wrap,
      {
        ...wrap.props,
        className: twJoin(
          wrap.props.className,
          'block h-full @container group/content-card group/button',
        ),
      },
      children,
    );
  }

  if (wrap) {
    logger.error(
      'Content Card could not be wrapped. The wrapping element is invalid.',
      wrap,
    );
  }

  return (
    <div className="block h-full @container group/content-card">{children}</div>
  );
};
